module.exports = __webpack_public_path__ + "img/news1-2.e7af2ec9.png";